import React, { useEffect, useRef } from 'react';
import { X, ArrowLeft, ArrowRight } from 'lucide-react';

const Lightbox = ({ photos, index, onClose, onNav }) => {
  const p = photos[index];
  const touch = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onNav(1);
      if (e.key === 'ArrowLeft') onNav(-1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose, onNav]);

  const onTouchStart = (e) => {
    touch.current = { x: e.touches[0].clientX, y: e.touches[0].clientY };
  };
  const onTouchEnd = (e) => {
    const dx = e.changedTouches[0].clientX - touch.current.x;
    const dy = e.changedTouches[0].clientY - touch.current.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) onNav(dx < 0 ? 1 : -1);
  };

  return (
    <div className="fixed inset-0 z-50 bg-paper/[0.98] backdrop-blur-sm flex flex-col" style={{ animation: 'fadeUp .25s both' }}>
      <div className="flex items-center justify-between px-4 sm:px-6 md:px-10 h-14 md:h-16 shrink-0">
        <span className="text-[11px] tracking-[0.2em] uppercase text-muted">
          {String(index + 1).padStart(2, '0')} / {String(photos.length).padStart(2, '0')}
        </span>
        <button onClick={onClose} className="text-ink hover:opacity-60 transition-opacity p-1" aria-label="Cerrar">
          <X size={24} strokeWidth={1.3} />
        </button>
      </div>

      <div
        className="flex-1 flex items-center justify-center px-2 sm:px-6 md:px-20 min-h-0 relative"
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        <button
          onClick={() => onNav(-1)}
          className="hidden sm:flex absolute left-1 md:left-6 text-ink/40 hover:text-ink transition-colors p-2 z-10"
          aria-label="Anterior"
        >
          <ArrowLeft size={30} strokeWidth={1.2} />
        </button>

        <img
          key={p.image}
          src={p.image}
          alt={p.title}
          draggable={false}
          className="max-h-full max-w-full object-contain select-none shadow-[0_12px_50px_rgba(0,0,0,0.35)]"
          style={{ animation: 'fadeUp .4s both' }}
        />

        <button
          onClick={() => onNav(1)}
          className="hidden sm:flex absolute right-1 md:right-6 text-ink/40 hover:text-ink transition-colors p-2 z-10"
          aria-label="Siguiente"
        >
          <ArrowRight size={30} strokeWidth={1.2} />
        </button>
      </div>

      <div className="text-center py-4 md:py-6 px-4 shrink-0">
        <div className="font-serif italic text-base md:text-lg text-ink">{p.title}</div>
        {(p.city || p.location) && (
          <div className="text-[10px] md:text-[11px] tracking-[0.2em] uppercase text-muted mt-1">
            {[p.city, p.location].filter(Boolean).join(' · ')}
          </div>
        )}
        <div className="sm:hidden text-[10px] tracking-[0.15em] uppercase text-muted/60 mt-3">Deslizá para navegar</div>
      </div>
    </div>
  );
};

export default Lightbox;
